/* Native back stack — the most recently opened screen/sheet handles the
   Android hardware/gesture back first. Used by useHistoryClose on native. */

const stack = [];

export const pushBackHandler = (fn) => {
  const entry = { fn };
  stack.push(entry);
  return () => {
    const i = stack.indexOf(entry);
    if (i >= 0) stack.splice(i, 1);
  };
};

/* Returns true when a registered screen consumed the back press. */
export const runBackHandler = () => {
  const top = stack[stack.length - 1];
  if (!top) return false;
  try { top.fn(); } catch (_) { /* noop */ }
  return true;
};

/* Covered-aware check: is this element actually tappable on screen now? */
const isOnTop = (el) => {
  const r = el.getBoundingClientRect();
  if (r.width < 4 || r.height < 4) return false;
  const x = Math.min(window.innerWidth - 1, Math.max(0, r.left + r.width / 2));
  const y = Math.min(window.innerHeight - 1, Math.max(0, r.top + r.height / 2));
  const hit = document.elementFromPoint(x, y);
  return !!hit && (hit === el || el.contains(hit));
};

/* Tap the visible in-screen back button (sub-page inside a tile), if any. */
export const clickVisibleBackButton = () => {
  const els = [...document.querySelectorAll('[data-testid*="back" i]')]
    .filter((el) => !/backdrop|background|feedback/i.test(el.getAttribute('data-testid')) && isOnTop(el));
  if (!els.length) return false;
  els[0].click();
  return true;
};
